import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_license_plate_by_licensePlateIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licensePlateId: number }): 
  Promise<{ result: { Id?: number, LocationId?: number, ShippingContainerId?: number, WarehouseId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licensePlateId)) {
      missingRequiredInParams.push('\'licensePlateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_license_plate_by_licensePlateId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
